// Blog list: load next page of articles via Section Rendering API
class BlogListNewUi extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.handleLoadMoreClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleLoadMoreClick);
  }

  handleLoadMoreClick = async (event) => {
    const button = event.target.closest('[data-load-more]');
    if (!button || button.getAttribute('aria-busy') === 'true') return;

    event.preventDefault();
    button.setAttribute('aria-busy', 'true');

    try {
      const nextPageDocument = await this.fetchSectionPage(button.getAttribute('href'));
      this.appendArticleCards(nextPageDocument);
      this.updateLoadMoreButton(button, nextPageDocument);
    } catch (error) {
      console.error('[blog-list] load more failed', error);
      window.location.href = button.href;
    } finally {
      button.removeAttribute('aria-busy');
    }
  };

  async fetchSectionPage(pageUrl) {
    const url = new URL(pageUrl, window.location.origin);
    url.searchParams.set('section_id', this.dataset.sectionId);

    const response = await fetch(url);
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    return new DOMParser().parseFromString(await response.text(), 'text/html');
  }

  appendArticleCards(nextPageDocument) {
    const articleList = this.querySelector('[data-blog-list]');
    articleList?.append(...nextPageDocument.querySelectorAll('[data-blog-list] > *'));
  }

  updateLoadMoreButton(button, nextPageDocument) {
    const nextPageUrl = nextPageDocument.querySelector('[data-load-more]')?.getAttribute('href');
    if (nextPageUrl) {
      button.setAttribute('href', nextPageUrl);
      return;
    }
    button.closest('.blog-list-new-ui__load-more')?.remove();
  }
}

if (!customElements.get('blog-list-new-ui')) {
  customElements.define('blog-list-new-ui', BlogListNewUi);
}
